import { call, put } from 'redux-saga/effects';
import {
  getKarloUsersSuccess,
  getKarloUsersFail,
  getUserDetailSuccess,
  getUserDetailFail,
} from 'app/features/karloUsers/karloUsersSlice.js';

import { requestHandler } from '../../services/requestHandler';
import moment from 'moment';

export function* getKarloUsersSaga(action) {
  try {
    const { page, pageSize, filtered } = action.payload;
    const _renderPage = pageSize * page;
    const data = {
      offset: _renderPage,
      limit: pageSize,
      field: 'createdAt',
      ordering: 'ASC',
    };
    const karloUsers = yield call(requestHandler, {
      method: 'POST',
      path: '/karlo-app/getUsers',
      data,
    });
    karloUsers.pages = yield call(
      Math.ceil,
      karloUsers.length / pageSize,
    );
    // console.log('success in karloUsers saga ', karloUsers);
    yield put(getKarloUsersSuccess({ karloUsers }));
  } catch (e) {
    const message = {
      title: 'Error',
      desc: `Ocurrió un error cuando se intentaba encontrar la información.
      Por favor, inténtelo de nuevo más tarde.`,
    };
    yield put(getKarloUsersFail({ message }));
    console.log('error in karloUsers saga', e);
  }
}

export function* getKarloUserDetailSaga(action) {
  try {
    const data = {
      userId: action.payload.userID,
    };
    console.log(data);
    const userDetail = yield call(requestHandler, {
      method: 'POST',
      path: '/karlo-app/getUserDetail',
      data,
    });
    yield put(getUserDetailSuccess({ userDetail }));
    console.log('success in users saga ', userDetail);
  } catch (e) {
    const message = {
      title: 'Error',
      desc: `Ocurrió un error cuando se intentaba encontrar la información del usuario.
      Por favor, inténtelo de nuevo más tarde.`,
    };
    yield put(getUserDetailFail({ message }));
    console.log('error in userDetail saga', e);
  }
}
